import React, { Component } from "react";

const AboutPostHeader = (props) => {
  return (
    <div>
      <div className="bg-light p-3">
        <div className="container text-center">
          <h1 className="font-weight-bold text-primary">{props.obj.head}</h1>
          <h6 className="text-danger">Request Code file of any below project at : <label className="font-weight-bold text-dark">2016cs438@student.uet.edu.pk</label></h6>
        </div>
      </div>
    </div>
  );
};

export default AboutPostHeader;
